/**
 * Finance → Payroll entry.
 * Mobile opens the payroll workspace directly. Desktop keeps Payroll Home.
 */
export function resolvePayrollModuleScreen(isDesktop) {
  return isDesktop ? "payroll_home" : "payroll_queue";
}
